<div>
  <app-breadcrumb></app-breadcrumb>
</div>

<h1 class="title">Gestion des entités - Consulter la liste des entités</h1>

<mat-card>
  <mat-card-content>
    <div class="table-header">
      <h2>Liste des entités</h2>
      <button (click)="openCreateDialog()" color="primary" mat-raised-button>
        <mat-icon>add</mat-icon>
        CRÉER UNE ENTITÉ
      </button>
    </div>

    <mat-divider></mat-divider>

    <div class="mat-elevation-z8">
      <mat-table [dataSource]="dataSource" matSort>

        <ng-container matColumnDef="libelle">
          <mat-header-cell *matHeaderCellDef mat-sort-header>Entité</mat-header-cell>
          <mat-cell *matCellDef="let element"> {{ element.libelle }}</mat-cell>
        </ng-container>

        <ng-container matColumnDef="interne">
          <mat-header-cell *matHeaderCellDef mat-sort-header>Type d'entité</mat-header-cell>
          <mat-cell *matCellDef="let element"> {{ getInterneExterneLabel(element.interne) }}</mat-cell>
        </ng-container>

        <ng-container matColumnDef="creation_datetime">
          <mat-header-cell *matHeaderCellDef mat-sort-header> Date de création</mat-header-cell>
          <mat-cell *matCellDef="let element"> {{ element.creation_datetime | date:'dd/MM/yyyy' }}</mat-cell>
        </ng-container>

        <ng-container matColumnDef="actions">
          <mat-header-cell *matHeaderCellDef> Actions</mat-header-cell>
          <mat-cell *matCellDef="let element">
            <mat-icon (click)="openEditDialog(element)">edit</mat-icon>
          </mat-cell>
        </ng-container>

        <ng-container matColumnDef="filter-libelle">
          <mat-header-cell *matHeaderCellDef>
            <mat-form-field class="my-filter-class">
              <mat-select (selectionChange)="applyFilter($event.value, 'libelle')" placeholder="Toutes">
                <mat-option value="">Toutes</mat-option>
                <mat-option value="true">Entitées activées</mat-option>
                <mat-option value="false">Entitées désactivées</mat-option>
              </mat-select>
            </mat-form-field>
          </mat-header-cell>
        </ng-container>

        <ng-container matColumnDef="filter-interne">
          <mat-header-cell *matHeaderCellDef>
            <mat-form-field class="my-filter-class">
              <mat-select (selectionChange)="applyFilter($event.value, 'type')" placeholder="Toutes">
                <mat-option value="">Toutes</mat-option>
                <mat-option value="true">Interne</mat-option>
                <mat-option value="false">Externe</mat-option>
              </mat-select>
            </mat-form-field>
          </mat-header-cell>
        </ng-container>

        <ng-container matColumnDef="emptyForDateCreation">
          <mat-header-cell *matHeaderCellDef></mat-header-cell>
        </ng-container>

        <ng-container matColumnDef="emptyForActions">
          <mat-header-cell *matHeaderCellDef></mat-header-cell>
        </ng-container>

        <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
        <mat-header-row *matHeaderRowDef="displayedColumnsFiltre; sticky: true" class="filtersRow"></mat-header-row>
        <mat-row *matRowDef="let row; columns: displayedColumns;" [class.inactif]="!row.actif"></mat-row>

      </mat-table>

      <mat-paginator [pageSizeOptions]="[10, 15, 20]"
                     aria-label="Select page of periodic elements"
                     showFirstLastButtons>
      </mat-paginator>
    </div>
  </mat-card-content>
</mat-card>
